import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Children, memo, useCallback, useMemo, useState, } from 'react';
import { IconButton } from '@mui/material';
import { isIOSApp } from 'webui/utils/version';
import { AllMapButtons, FullScreenButton, SearchControl, WhereIAm, WhereIsMyCar, } from './components';
import { useAction, usePartialAppSelector } from 'shared/hooks/redux/hooks';
import { setMapCenterAndZoom, setMapZoom } from 'shared/map/model/slice';
import { select_device_map } from 'shared/map/model/selectors';
import { useMap } from 'react-leaflet';
import { MapOptions } from './components/options';
import { useBooleanState } from 'shared/hooks/state/boolean';
import { onPushFullScreen, useIsFullscreen, } from 'shared/map/ui/components/control-buttons/components/fullscreen/lib';
import { InfoBox } from 'shared/map/ui/components/infobox';
import { a2l } from 'shared/map/lib/utils';
import { escape_html } from 'utils';
import { usePartial } from 'shared/hooks/utils';
import './components/options/options.sass';
import './components/zoom/zoom.sass';
//Вставляем в попап результаты поиска готовым объектом
function newSearchContent(search_info) {
    if (search_info == null) {
        return '';
    }
    return `\
            <div class="ui-map-search-result"> \
                <div class="ui-map-search-result-title">АДРЕС</div> \
                <div class="ui-map-search-result-name">${escape_html(search_info.name)}</div> \
                <div class="ui-map-search-result-description">${escape_html(search_info.description)}</div> \
            </div>
            `;
}
export const ControlButtons = memo(function ControlButtons(props) {
    const { showZoom, hide_for_map_dashboard, showSearch, device_id, showOptionsMenu, onSearchDone, onCenterOnUser, } = props;
    const map = useMap();
    const [follow, noFollow, setFollow] = useBooleanState(false);
    const onWhereIAmClick = useCallback(() => {
        console.log('where i am');
        noFollow();
        onCenterOnUser?.();
    }, []);
    const map_state = usePartialAppSelector(select_device_map, device_id);
    const onWantMapZoom = useAction(setMapZoom);
    const onWantMapCenterAndZoom = useAction(setMapCenterAndZoom);
    //Если изменились координаты, отображаемы на карте
    const [search_results, setSearchResults] = useState(null);
    const [search_results_shown, noSearchResultShown, setSearchResultsShown] = useBooleanState(false);
    const isFullScreen = useIsFullscreen();
    //Когда поиск будет завершён
    const _onSearchDone = useCallback((search_info) => {
        noFollow();
        setSearchResultsShown();
        setSearchResults(search_info);
        onWantMapCenterAndZoom({ center: search_info.loc, zoom: 16, device_id });
        onSearchDone?.(search_info);
    }, [onWantMapCenterAndZoom, onSearchDone, device_id]);
    const zoom = useMemo(() => map_state?.zoom ?? 3, [map_state?.zoom]);
    const onIncreaseZoom = useCallback((event) => {
        event.preventDefault();
        onWantMapZoom({ zoom: zoom + 1, device_id });
        map.setZoom(zoom + 1);
    }, [onWantMapZoom, zoom, device_id]);
    const onDecreaseZoom = useCallback((event) => {
        event.preventDefault();
        onWantMapZoom({ zoom: zoom - 1, device_id });
        map.setZoom(zoom - 1);
    }, [onWantMapZoom, zoom, device_id]);
    const onClickFullScreen = usePartial(onPushFullScreen, map.getContainer());
    return (_jsxs(_Fragment, { children: [showOptionsMenu && !isFullScreen && (_jsx(MapOptions, { hide_for_map_dashboard: hide_for_map_dashboard })), search_results_shown && search_results != null && (_jsx(InfoBox, { position: a2l(search_results.loc), unsafe_html_content: newSearchContent(search_results), onClose: noSearchResultShown })), _jsx(AllMapButtons, { upChild: Children.toArray([
                    // Карту на полный экран
                    !isIOSApp() && (_jsx(FullScreenButton, { onClickFullScreen: onClickFullScreen })),
                    //Кнопка для уменьшения масштаба
                    showZoom && (_jsx(IconButton, { disableRipple: true, "aria-controls": "zoom-out", className: "ui-map-zoom ui-map-zoom-out ui-icon-map-button-zoom-out", title: "\u0423\u043C\u0435\u043D\u044C\u0448\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431", onClick: onDecreaseZoom, size: "large" })),
                    //Кнопка для увеличения масштаба
                    showZoom && (_jsx(IconButton, { disableRipple: true, "aria-controls": "zoom-in", className: "ui-map-zoom ui-map-zoom-in ui-icon-map-button-zoom-in", title: "\u0423\u0432\u0435\u043B\u0438\u0447\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431", onClick: onIncreaseZoom, size: "large" })),
                ]), leftChild: Children.toArray([
                    // Кнопка по которой найдём себя
                    _jsx(WhereIAm, { showLocation: onWhereIAmClick }, 1),
                    // Кнопка по которой найдём устройство
                    hide_for_map_dashboard ? null : (_jsx(WhereIsMyCar, { device_id: device_id, follow: follow, setFollow: setFollow, noFollow: noFollow }, 2)),
                    // Кнопка для поиска объектов
                    window.screen.width >= 320 && showSearch ? (_jsx(SearchControl, { onSearchDone: _onSearchDone }, 3)) : null,
                ]) })] }));
});
